<template>
  <div class="profile">
    <!-- header -->
    <div class="profile-header">
      <span class="profile-header__name">SU-27C</span>
      <div class="profile-header__image">
        <img src="/assets/img/avatar.jpg" alt="Avatar" />
      </div>
    </div>

    <!-- dropdown -->
    <this-dropdown :menu="dropdownMenu" right>
      <div class="profile-info">
        <this-rank count="5" />

        <div class="profile-info__body">
          <div class="profile-info__description">
            <div class="profile-info__title">Login User</div>
            <div class="profile-info__subtitle">
              User Rank: <span>Lieutenant</span>
            </div>
          </div>
        </div>
      </div>
    </this-dropdown>
  </div>
</template>

<script>
import ThisDropdown from "./dropdown";
import ThisRank from "./profile-rank";

export default {
  name: "HeaderProfile",

  components: {
    ThisDropdown,
    ThisRank
  },

  data() {
    return {
      dropdownMenu: [
        {
          title: "Logbook",
          icon: "contacts",
          link: "#"
        },
        {
          title: "Setup aircraft",
          icon: "cog",
          link: "#"
        },
        {
          title: "Setup controls",
          icon: "joystick",
          link: "#"
        }
      ]
    };
  }
};
</script>

<style>
@import "./profile.css";
</style>
